import { j as a } from "./atoms-v218.js";
import { forwardRef as de, useMemo as l, useState as fe, useRef as me, useImperativeHandle as ue, createElement as pe } from "react";
import { useFloating as ge, useClick as Ce, useFocus as De, useDismiss as he, useRole as xe, useInteractions as Se, FloatingPortal as be } from "./atoms-v280.js";
import { useTheme as ve } from "styled-components";
import { useBreakpoints as Te } from "./atoms-v251.js";
import { getCellTime as Re } from "./atoms-v259.js";
import { useCalendarContext as ke } from "./atoms-v2766.js";
import { Tooltip as Oe, TableDataCell as Pe, TooltipArrow as we, TOOLTIP_ARROW_HEIGHT as U, TOOLTIP_ARROW_MARGIN as Ie } from "./atoms-v21303.js";
import { CalendarTableDataCellContent as Me } from "./atoms-v21304.js";
import { useCellState as ye } from "./atoms-v21179.js";
import { getTodaysDateTimeAtStart as Ae, getPriceText as Fe, getStrikePriceText as Be, getCellHeight as Ee } from "./atoms-v21180.js";
import { inline as $e, flip as je, shift as He, autoUpdate as Le } from "./atoms-v283.js";
import { offset as Ne } from "./atoms-v284.js";
import { arrow as Ue } from "./atoms-v2719.js";
import { motion as _e } from "./atoms-v2709.js";
import { AnimatePresence as Ge } from "./atoms-v2710.js";
function We({
  colorTheme: D = "light",
  dateConfig: k,
  dateConfigIdx: _,
  isFirstOfType: G,
  isLastOfType: W,
  isLoading: q,
  month: z
}, J) {
  const { domBuilder: n, userInteractions: s } = ke(), { current: O } = Te(), {
    cellData: e,
    cellUID: t,
    hasUnavailableInConsideredRange: K,
    isBridgeDateInclusive: m,
    isCheckoutDate: u,
    isConsideredBridgeDate: Q,
    isConsideredBridgeDateEffective: P,
    isDisabledByMaxSelectionBoundsCells: w,
    isDisabledByMinSelectionBoundsCells: h,
    isDisabledForAvailability: c,
    isDisabledForNextMonth: x,
    isDisabledForOverflow: d,
    isDisabledForPreviousMonth: S,
    isDisabledForRange: b,
    isDisabledInclusive: v,
    isEndDate: r,
    isEndOfActiveRangeCell: I,
    isHighlightedOverflowCell: M,
    isHoverDisabledByUnavailable: p,
    isHovered: y,
    isMinSelectionOverflowCell: A,
    isRightSideBoundaryOfConsideredBridgeDates: F,
    isRightSideBoundaryOfMinSelectionRange: B,
    isSelectedBridgeDate: g,
    isStartDate: T,
    weekdayIdx: V
  } = ye({
    dateConfig: k,
    month: z,
    weekdayIdx: _
  }), i = ve(), E = l(() => Ae() > Re(t) ? !1 : (n == null ? void 0 : n.isPriceShown) ?? !1, [t, n == null ? void 0 : n.isPriceShown]), C = l(() => !!(e != null && e.salePrice), [e]), X = l(
    () => Fe(
      e,
      r,
      C,
      c,
      g
    ),
    [e, r, C, c, g]
  ), $ = l(
    () => Be(e, r, C),
    [e, r, C]
  ), Y = l(() => Ee(O), [O]), [R, j] = fe(!1), H = me(null), { context: f, floatingStyles: Z, refs: L } = ge({
    middleware: [
      $e(),
      Ne(U + Ie),
      je(),
      He(),
      Ue({
        element: H
      })
    ],
    onOpenChange: j,
    open: R,
    placement: "top",
    whileElementsMounted: Le
  }), ee = Ce(f), te = De(f), ie = he(f), oe = xe(f, {
    role: "tooltip"
  }), { getFloatingProps: ne, getReferenceProps: se } = Se([ee, te, ie, oe]), re = l(() => _e(Oe), []);
  ue(
    J,
    () => ({
      state() {
        return {
          cellData: e,
          cellUID: t,
          hasUnavailableInConsideredRange: K,
          isBridgeDateInclusive: m,
          isCheckoutDate: u,
          isConsideredBridgeDate: Q,
          isConsideredBridgeDateEffective: P,
          isDisabledByMaxSelectionBoundsCells: w,
          isDisabledByMinSelectionBoundsCells: h,
          isDisabledForAvailability: c,
          isDisabledForNextMonth: x,
          isDisabledForOverflow: d,
          isDisabledForPreviousMonth: S,
          isDisabledForRange: b,
          isDisabledInclusive: v,
          isEndDate: r,
          isEndOfActiveRangeCell: I,
          isHighlightedOverflowCell: M,
          isHoverDisabledByUnavailable: p,
          isHovered: y,
          isMinSelectionOverflowCell: A,
          isRightSideBoundaryOfConsideredBridgeDates: F,
          isRightSideBoundaryOfMinSelectionRange: B,
          isSelectedBridgeDate: g,
          isStartDate: T,
          weekdayIdx: V
        };
      }
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  function ae(o) {
    if (b && !m && j(!R), N) {
      o.preventDefault(), o.stopPropagation();
      return;
    }
    if (!u && (c || d || w || h && !m)) {
      o.preventDefault(), o.stopPropagation();
      return;
    }
    s.onCellClick(t, o);
  }
  function le(o) {
    d || S || x || s.onCellMouseEnter(t, o);
  }
  function ce(o) {
    s.onCellMouseLeave(t, o);
  }
  const N = (p || v) && !u;
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx(
      Pe,
      {
        ...se(),
        $hasPriceContent: E,
        $hasStrikePrice: !!$,
        $isDisabledForOverflow: d,
        $isEndDate: r,
        $isNotAllowed: p,
        $isStartDate: T,
        "aria-disabled": N,
        "aria-label": `Calendar Date for ${t}`,
        "data-testid": "calendar-table-data-cell",
        id: t,
        onClick: ae,
        onMouseEnter: le,
        onMouseLeave: ce,
        ref: L.setReference,
        children: /* @__PURE__ */ a.jsx(
          Me,
          {
            colorTheme: D,
            dateConfig: k,
            hasEndDateSelected: !!s.endingCellData,
            hasEndOfActiveRangeCell: !!s.endOfRangeActiveCell && s.endOfRangeActiveCell !== t,
            hasMinSelection: ((e == null ? void 0 : e.minSelection) || 0) > 0,
            hasPriceContent: E,
            height: Y,
            isBridgeDateInclusive: m,
            isCheckoutDate: u,
            isConsideredBridgeDate: P,
            isDisabledForAvailability: c,
            isDisabledForNextMonth: x,
            isDisabledForOverflow: d,
            isDisabledForPreviousMonth: S,
            isDisabledForRange: b,
            isDisabledInclusive: v || p,
            isEndDate: r,
            isEndOfActiveRangeCell: I,
            isFirstOfType: G,
            isHighlightedOverflowCell: M,
            isHovered: y,
            isLastOfType: W,
            isLoading: q,
            isMinSelectionOverflowCell: A,
            isRightSideBoundaryOfConsideredBridgeDates: F,
            isRightSideBoundaryOfMinSelectionRange: B,
            isSelectedBridgeDate: g,
            isStartDate: T,
            priceText: X,
            strikePriceText: $,
            width: "calc(100% - 4px)"
          }
        )
      }
    ),
    /* @__PURE__ */ a.jsx(Ge, { children: R ? /* @__PURE__ */ a.jsx(be, { id: t, children: /* @__PURE__ */ pe(
      re,
      {
        ...ne(),
        $colorTheme: D,
        animate: "visible",
        exit: "hidden",
        id: `tooltip-${t}`,
        initial: "hidden",
        key: `tooltip-${t}`,
        ref: L.setFloating,
        style: Z,
        variants: {
          hidden: {
            opacity: 0,
            top: 24,
            transition: {
              duration: (i == null ? void 0 : i.get("tokens.motion.duration.moderate.01")) / 1e3,
              ease: i == null ? void 0 : i.get("tokens.motion.easing.exit")
            }
          },
          visible: {
            opacity: 1,
            top: 0,
            transition: {
              duration: (i == null ? void 0 : i.get("tokens.motion.duration.moderate.01")) / 1e3,
              ease: i == null ? void 0 : i.get("tokens.motion.easing.entrance")
            }
          }
        }
      },
      /* @__PURE__ */ a.jsx(
        we,
        {
          $colorTheme: D,
          context: f,
          height: U,
          ref: H
        }
      ),
      h ? n.text.minSelectionText(s.startingCellData.minSelection) : n.text.maxSelectionText(s.startingCellData.maxSelection)
    ) }) : null })
  ] });
}
const at = de(We);
export {
  at as CalendarTableDataCell
};
